const { withStyles, Link } = require("@material-ui/core");

const StyledLink = withStyles((theme) => ({
  root: {
    color: theme.palette.accent[500]
  },
}))(Link);

export default StyledLink;